export const colors =
{
    primary: {
        hex: '#13005A', //azul oscuro
        rg: 'rgb(19, 0, 90)'
    },
    secondary: {
        hex: '#E21818', //rojo
        rg: 'rgb(226, 24, 24)'
    },
    tertiary: {
        hex: '#00337C', //azul medio
        rg: 'rgb(0, 51, 124)'
    },
    quaternary: {
        hex: '#1C82AD', //celeste
        rg: 'rgb(28, 130, 173)'
    },
    
    // primary: {
    //     hex: '#13005A', //azul oscuro
    //     rg: 'rgb(19, 0, 90)'
    // },
    // secondary: {
    //     hex: '#00337C', //azul medio
    //     rg: 'rgb(0, 51, 124)'
    // },
    // tertiary: {
    //     hex: '#1C82AD', //turquesa
    //     rg: 'rgb(28, 130, 173)'
    // },
    // quaternary: {
    //     hex: '#03C988', //verde
    //     rg: 'rgb(3, 201, 136)'
    // },
}